import { useMutation } from 'react-query';
import Endpoints from '../../../constants/endpoints';
import { useServices } from '../../../services/useServices';

export const useMcpGrant = () => {
  const {
    auth: { requestMcpGrant }
  } = useServices();

  return useMutation(Endpoints.authMcpGrant, (requestId: string) => requestMcpGrant(requestId));
};
